import { AddCircle, RemoveCircle, Search } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import * as setup from 'setup';

export default function MapControls() {
    const game = useGame();
    const zoom = game.map?.zoom || 0;

    function handleSpeedClick(increase: boolean) {
        const closest = Math.pow(2, Math.floor(Math.log(game.speed) / Math.log(2)));
        const value = closest * (increase ? 2 : 0.5);
        const speed = closest < game.speed && value < closest ? closest : value;
        game.setSpeed(speed);
    }

    function handleZoomClick(e: any, increase: boolean) {
        const { altMultiplier, controlStep, shiftMultiplier } = setup.map.zoom;
        const step = controlStep * (e.altKey ? altMultiplier : 1) * (e.shiftKey ? shiftMultiplier : 1);
        game.map.changeZoom(increase, step);
    }

    return (
        <Box bottom={0} className="map-controls" color="#3F51B5" position="absolute" right={0} zIndex={1}>
            <Box alignItems="center" display="flex" justifyContent="flex-end">
                <Search />
                <IconButton
                    disabled={zoom === setup.map.zoom.min}
                    title="Decrease map zoom"
                    onClick={e => handleZoomClick(e, true)}
                >
                    <RemoveCircle />
                </IconButton>
                <IconButton
                    disabled={zoom === setup.map.zoom.max}
                    title="Increase map zoom"
                    onClick={e => handleZoomClick(e, false)}
                >
                    <AddCircle />
                </IconButton>
            </Box>
            <Box alignItems="center" display="flex" justifyContent="flex-end">
                <Typography variant="montserrat618">{game.speed}x</Typography>
                <IconButton
                    disabled={game.speed === setup.map.speed.min}
                    title="Decrease map zoom"
                    onClick={() => handleSpeedClick(false)}
                >
                    <RemoveCircle />
                </IconButton>
                <IconButton
                    disabled={game.speed === setup.map.speed.max}
                    title="Increase map zoom"
                    onClick={() => handleSpeedClick(true)}
                >
                    <AddCircle />
                </IconButton>
            </Box>
        </Box>
    );
}
